import { PriceDisplay } from '../../components/PriceDisplay';
import {
  LeftContent,
  MetaLine,
  PriceAmount,
  PriceNote,
  PriceWrapper,
  Row,
  TextContent,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  Title,
} from './BookingSummaryRow.styles';
import type { BookingSummaryRowProps } from './BookingSummaryRow.types';

export function BookingSummaryRow({
  title,
  image,
  meta = [],
  price,
  priceNote,
  noImageLabel,
}: BookingSummaryRowProps) {
  return (
    <Row data-testid="booking-summary-row">
      <LeftContent>
        <Thumbnail>
          {image?.src ? (
            <ThumbnailImage src={image.src} alt={image.alt ?? title} />
          ) : (
            <ThumbnailPlaceholder
              data-testid="booking-summary-thumbnail-placeholder"
              aria-label={noImageLabel}
            />
          )}
        </Thumbnail>
        <TextContent>
          <Title>{title}</Title>
          {meta.map((line, index) => (
            <MetaLine key={`${line}-${index}`}>{line}</MetaLine>
          ))}
        </TextContent>
      </LeftContent>

      {(price || priceNote) && (
        <PriceWrapper>
          {price && (
            <PriceAmount>
              <PriceDisplay
                amount={price.amount}
                currencyCode={price.currencyCode}
                locale={price.locale}
                size="small"
              />
            </PriceAmount>
          )}
          {priceNote && <PriceNote>{priceNote}</PriceNote>}
        </PriceWrapper>
      )}
    </Row>
  );
}
